import { Stack } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import type React from "react"
import CheckoutButton from "../components/CheckoutButton"
import MiniCart from "../components/MiniCart"

const MiniCartPage: React.FC = () => {
  return (
    <Stack>
      <MiniCart />
      <CheckoutButton />
    </Stack>
  )
}

export const Route = createFileRoute("/minicart")({
  component: MiniCartPage,
})

export default MiniCartPage
